import { ShopifyItemCatalogCard } from './shopifyItemCatalogCard';
import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_BY_IDS } from '../../../../../../app/graphql';
import { Marketplace, ShopifyProduct } from '../../../../../../app/graphql/generated/cart/graphql';

interface ItemCatalogCardValue {
  products: {
    productId?: string;
    variantId: string;
    quantity: number;
    price?: number | null;
  }[];
  currency: string | undefined;
}

export const ShopifyItemCatalogCardTable = (props: ItemCatalogCardValue) => {
  const { loading, data } = useQuery(GET_PRODUCTS_BY_IDS, {
    variables: {
      input: props.products.map((product) => {
        return { id: product.productId || product.variantId, marketplace: Marketplace.Shopify };
      }),
    },
  });

  if (loading || !data?.productsByIds?.products) {
    return null;
  }

  const productsMap: Record<string, ShopifyProduct> = {};
  (data?.productsByIds?.products ?? []).forEach((product: ShopifyProduct | null) => {
    if (product) {
      productsMap[product.id] = product;
    }
  });

  return (
    <table id="item_catalog_table">
      <tbody>
        <tr className="item-catalog-table-header-row">
          <th>Item</th>
          <th>Product</th>
          <th>Quantity</th>
          <th>Price</th>
        </tr>
        {(props.products ?? []).map((product) => (
          <ShopifyItemCatalogCard
            key={product.variantId}
            quantity={product.quantity}
            productId={product.productId}
            variantId={product.variantId}
            price={product.price}
            currency={props.currency}
            product={productsMap[product.productId || product.variantId]}
          />
        ))}
      </tbody>
    </table>
  );
};
